import React, { useState } from "react";
import { Box, Button, TextField, Stack, Paper } from "@mui/material";
import { BulletinItem } from "../../utils/BulletinBoardAPIRequest";

interface Props {
    item: BulletinItem | null;
    onSubmitItem: (item: BulletinItem) => void;
    onCancel: () => void;
}

const BulletinBoardForm: React.FC<Props> = ({ item, onSubmitItem, onCancel }) => {
    const [title, setTitle] = useState(item?.title || "");
    const [content, setContent] = useState(item?.content || "");

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        console.log("Submitting bulletin item:", { title, content });
        if (!title.trim() || !content.trim()) return;
        onSubmitItem({
            _id: item?._id || "",
            title,
            content,
            createdAt: item?.createdAt || new Date().toISOString(),
        });
    };

    return (
        <Paper sx={{ p: 2, mb: 2 }}>
            <form onSubmit={handleSubmit}>
                <Stack spacing={2}>
                    <TextField
                        label="Title"
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                        required
                        fullWidth
                    />
                    <TextField
                        label="Content"
                        value={content}
                        onChange={(e) => setContent(e.target.value)}
                        required
                        fullWidth
                        multiline
                        minRows={3}
                    />
                    <Box display="flex" gap={2}>
                        <Button type="submit" variant="contained" color="primary">
                            {item ? "Update" : "Create"}
                        </Button>
                        <Button variant="outlined" color="secondary" onClick={onCancel}>
                            Cancel
                        </Button>
                    </Box>
                </Stack>
            </form>
        </Paper>
    );
};

export default BulletinBoardForm;
